// theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#475B63",
    },
    secondary: {
      main: "#ffad61",
    },
    background: {
      default: "#EAEEF0",
      white: "#ffffff",
      button: "#475B63",
      appbar: "#475B63",
      card: "#FFFFFF",
      dialog: "#d19191",
      notification: "#EAEEF0",
      input: "#FFFFFF",
      dataGrid: "#FFFFFF",
      l1: "#EAEEF0",
      l2: "#e1c9a8",
      l3: "#d19191",
      l4: "#d19191",
      l5: "#475B63",
      l6: "#8fbdcf",
      l0: "#FFFFFF",
      c1: "#9fe3a8",
      c2: "#e1c9a8",
      c3: "#d19191",
      c0: "#FFFFFF",
    },
    text: {
      primary: "#333333",
      white: "#ffffff",
      black: "#000000",
      validInput: "#475B63",
      invalidInput: "#d19191",
      disabledInput: "#a0a0a0",
    },
    light: {
      l100: "#f0f0f0",
    },
  },
  typography: {
    fontFamily: "Arial, sans-serif",
  },
});

export default theme;
